export default "__VITE_ASSET__DtWzRNed__"